import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M14.6693 7.99998C14.6693 11.6819 11.6845 14.6666 8.0026 14.6666C4.32071 14.6666 1.33594 11.6819 1.33594 7.99998C1.33594 4.31808 4.32071 1.33331 8.0026 1.33331C11.6845 1.33331 14.6693 4.31808 14.6693 7.99998ZM2.66927 7.99998C2.66927 10.9455 5.05708 13.3333 8.0026 13.3333C10.9481 13.3333 13.3359 10.9455 13.3359 7.99998C13.3359 5.05446 10.9481 2.66665 8.0026 2.66665C5.05708 2.66665 2.66927 5.05446 2.66927 7.99998Z",
  fill: "white"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M8.0026 1.33332C8.87808 1.33332 9.74499 1.50576 10.5538 1.84079C11.3627 2.17582 12.0976 2.66689 12.7166 3.28595C13.3357 3.905 13.8268 4.63993 14.1618 5.44877C14.4968 6.2576 14.6693 7.12451 14.6693 7.99999L13.3359 7.99999C13.3359 7.29961 13.198 6.60608 12.93 5.95901C12.6619 5.31194 12.2691 4.724 11.7738 4.22875C11.2786 3.73351 10.6907 3.34066 10.0436 3.07263C9.39651 2.80461 8.70299 2.66666 8.0026 2.66666L8.0026 1.33332Z",
  fill: "var(--loader-color, #0079F2)"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }